import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Autocomplete, Checkbox, CircularProgress, Collapse, Grid, Stack, TextField, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import React, { useRef } from "react";
import { Controller, useForm } from 'react-hook-form';
import { connect } from "react-redux";
import { useNavigate } from 'react-router';
import { DeviceModel, OptionItem, PageData } from "../../../models";
import { Path as RoutePath } from "../../../path";
import { customerLabelName, deviceTypeOptions, limitPullDownCustomers } from '../../../statics';
import { ApplicationState, FetchState, actionCreators, selectors } from "../../../store";
import palette from '../../../theme/palette';
import FetchHelper from "../../FetchHelper";
import NotifyGrid from './NotifyGrid';
import { useDispatch } from "react-redux";

// -------------
// FETCH ID
const getAllCustomers = "GET_ALL_CUSTOMERS";
const fetchId = "REPORT_LIST";
const menusFetchId = 'MENUS_FETCH';
const CUSTOMER_GROUP_LIST = "CUSTOMER_GROUP_LIST";

// 検索フォーム
export interface SearchItemForm {
    limit: number;
    page: number;
    group_id: OptionItem | null;
    customer_id: OptionItem | null;
    place: string;
    manage_customer_name: string;
    settingBase:any;
    device_type: OptionItem | null;
}

// 初期値設定
const initialValue: SearchItemForm = {
    limit: 50,
    page: 0,
    group_id: null,
    customer_id: null,
    place: "",
    manage_customer_name: "",
    settingBase:[],
    device_type: null,
}

const initialPageData: PageData = {
    rowFrom: '0',
    rowTo: '0',
    totalRow: '0',
    currPage: '0',
    totalPage: '0',
};

// -------------
// Props
export type NotifyListProps = ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps;

// -------------

// Component
export const NotifyList = (props: NotifyListProps) => {
    // region field
    const { onSearch,onError,onGetAuthRole,onSearchCustomerGroups,fetchStateMenu, initialPageSize } = props;

    const { control, handleSubmit, setValue, getValues } = useForm<SearchItemForm>({
        criteriaMode: "all",
        defaultValues: {...initialValue, limit: initialPageSize["device_notificationlist"]}
    });

    localStorage.setItem('lastActiveFormPath', RoutePath.NotifyList);
    localStorage.setItem('title', '通報一覧');

    const [keyword, setKeyword] = React.useState("");
    const [openSearch, setOpenSearch] = React.useState(false);
    const [listData, setListData] = React.useState<DeviceModel[]>([]);
    const [customersOption, setCustomersOption] = React.useState<OptionItem[]>([]);
    const [customerGroupsOption,setCustomerGroupsOption] = React.useState<OptionItem[]>([]);
    const [colState, setColState] = React.useState<any>();
    const [loadingFlag, setLoadingFlag] = React.useState(true);
    const [loadingCustomerGroupFlag, setLoadingCustomerGroupFlag] = React.useState(true);
    const [authRole, setAuthRole] = React.useState<any>();
    const [customerGroupsListShow, setCustomerGroupsListShow] = React.useState<OptionItem[]>([]);
    const [pageData, setPageData] = React.useState(initialPageData);
    let navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('id');
    const gridRef = useRef() as any;
    const dispatch = useDispatch();

    // #endRegion Field

    // #region useEffect

    // 初回検索実行
    React.useEffect(() => {
        if(fetchStateMenu.data){
            setAuthRole(fetchStateMenu.data);
        } else {
            onGetAuthRole();
        }
        handleSearchSubmit(getValues());
        setLoadingCustomerGroupFlag(true);
        const params = new Map<string, any>();
        params.set("limit", 1000);
        onSearchCustomerGroups(params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if(authRole){
            if(authRole.auth_role_map["MS-customergroup-get"]){
                setCustomerGroupsListShow(customerGroupsOption);
            }else if(authRole.auth_role_map["MS-customergroupbelong-get"]){
                const customer_options = customerGroupsOption.filter((item:any) => item.value == authRole.company_group_id);
                setCustomerGroupsListShow(customer_options);
            }else{
                setCustomerGroupsListShow([]);
            }
        }
    },[authRole,customerGroupsOption]);

    React.useEffect(() => {
        // グラフ表示用データの更新
        // --------------------------------
        if (myParam) {
            listData.forEach((item: any) => {
                item.serial_no = myParam
            });
            setListData(() => [...listData])
        }
        else {
            listData.forEach((item: any) => {
                item.serial_no = Math.floor(Math.random() * 10000).toString().padStart(5, '0')
            });
            setListData(() => [...listData])
        }
        // eslint-disable-next-line
    }, [myParam]);

    // #endregion useEffect

    // #region handleFunction

    const handleFetchAuthRoleSuccess = (data: any) => {
        console.log('>>> handleSuccess');
        if (data){
            setAuthRole(data);
        }
    }    

    // 検索実行
    const handleSearchSubmit = (value: SearchItemForm) => {
        setLoadingFlag(true);
        if (gridRef && gridRef.current) {
            setColState(gridRef.current.saveState());
        }

        const params = new Map<string, any>();
        if (value.limit) params.set("limit", value.limit);
        if (value.page) params.set("page", value.page - 1);
        if (value.customer_id && value.customer_id.value) params.set("customer_id", value.customer_id.value);
        if (value.place) params.set("place", value.place);
        if (value.group_id && value.group_id.value) params.set("group_id", value.group_id.value);
        if (value.manage_customer_name) params.set("manage_customer_name", value.manage_customer_name); 
        if (value.device_type && value.device_type.value) params.set("device_type", value.device_type.value);
        const settingBase = [...value.settingBase];
        settingBase.sort((a:any,b:any) => {
            return Number(a.base_id) - Number(b.base_id);
        })
        let base_id = settingBase.map((item) => item.base_id).join("_");
        if(base_id){
            params.set("base_id", base_id);
        }       
        onSearch(params);
    }

    // 検索正常終了時
    const handleSuccess = (data: any) => {
        if (data && data.result_code == 0) {
            data.results.forEach((element: { isSelect: boolean; }) => {
                element.isSelect = false;
            });
            if (gridRef && gridRef.current) {
                gridRef.current.setRowData(data.results);
            }
            setListData(() => [...data.results]);

            const totalCount = data.total_count;
            const pageSize = getValues('limit');
            const page = Number(data.page) + 1;
            const totalPage = Math.ceil(totalCount / pageSize);
            const rowFrom = (pageSize * page - pageSize) + 1;
            const rowTo = (pageSize * page) > totalCount ? totalCount : (pageSize * page);

            const updateData: PageData = {
                rowFrom: rowFrom.toLocaleString(),
                rowTo: rowTo.toLocaleString(),
                totalRow: totalCount.toLocaleString(),
                currPage: page.toLocaleString(),
                totalPage: totalPage.toLocaleString(),
            };
            setPageData(updateData);
        } else {
            if (gridRef && gridRef.current) {
                gridRef.current.setRowData([]);
            }
        }
        setLoadingFlag(false);
    };

    // 検索エラー時
    const handleError = (success: boolean, data: any, error: any) => {
        // setHideMessage(true);
        setLoadingFlag(false);
        onError(success, data, error);
        gridRef.current.hideOverlay();
    };

    // ページ数変更時にAPI検索する
    const handleChangePageData = (name: any, value: any) => {
        // 値変更
        setValue(name, value);
        if (name === 'limit') {
            const initialPageSizeTemp = { ...initialPageSize, device_notificationlist: Number(value) };
            dispatch({type:"SET_INIT_PAGE_SIZE",payload:{data:initialPageSizeTemp}});
            setValue("page", 0);
        }
        handleSearchSubmit(getValues());
    };

    // ハンドルオープン
    const handleOpen = (setState: any) => {
        if (gridRef && gridRef.current) {
            setColState(gridRef.current.saveState());
        }
        setState((prev: boolean) => !prev);
    };

    // 検索条件をクリアします
    const handleClearSeachCondition = () => {
        setValue("customer_id", null);
        setValue("group_id", null);
        setValue("place", "");
        setValue("manage_customer_name", "");
        setValue("settingBase",[]);
        setValue("device_type", null);
    };

    const handleChangeKeyword = (value: string) => {
        setKeyword(value);
        if (gridRef && gridRef.current) {
            setColState(gridRef.current.saveState());
        }
    };

    const handleSearch = (data: any) => {
        setValue("page", 0)
        handleSearchSubmit(getValues())
    };

    const handleFetchCustomerGroupListSucess = (data:any) => {
        setLoadingCustomerGroupFlag(false);
        if(data && data.result_code == 0){            
            const list_option = data.results.map((item:any) => {
                return {value:item.group_id,label:item.name} as OptionItem;
            });
            setCustomerGroupsOption(list_option);
        }
    };

    const handleFetchCustomersSuccess = (data:any) => {
        if(data && data.result_code == 0){
            const customers = data.results.map((element:any) => {
                return {
                    id: element.id,
                    name: element.name,
                }
            }).sort((a:any, b:any) => a.name.localeCompare(b.name, "ja-JP"));

            if(customers){
                setCustomersOption(customers.map((x: any) => { return { value: x.id, label: x.name, attribute: '' } as OptionItem }));
            }
        }
    };

    const handleFetchCustomerGroupListError = (success:any, data:any, error:any) => {
        setLoadingCustomerGroupFlag(false);
    };

    const handleShowDetail = (mainid:string) => {
        navigate(`${RoutePath.NotificationsEdit}?mainid=${mainid}`);
    };
    // #endregion handleFunction

    // #region Component
    return (
        <>
            <FetchHelper fetchId={getAllCustomers}
                url={`/master/customers/condget`}
                method="GET"
                request={true}
                onComplete={(success, data, error) => {
                    success ? handleFetchCustomersSuccess(data) : handleError(success, data, error)
                }}
            />

            {(loadingFlag || loadingCustomerGroupFlag) && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}

            <div style={{ height: '100%', width: '100%' }}>
                <form onSubmit={handleSubmit(handleSearch)}>
                    <Stack spacing={1} mb="10px" style={{ border: openSearch ? "2px solid gray" : '', borderRadius: "15px" }}>
                        <div style={{ cursor: 'pointer', display: 'inline-block', marginLeft: '10px' }} onClick={() => { handleOpen(setOpenSearch); }}>
                            <div style={{ display: 'inline-block' }}>
                                <Typography variant="h6" >検索条件</Typography>
                            </div>
                            <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                                {
                                    openSearch ? <ArrowDropDownIcon /> : <ArrowRightIcon />
                                }
                            </div>
                        </div>
                        <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom: "10px" }}>
                            <Collapse in={openSearch} timeout="auto" unmountOnExit>
                                <Grid
                                    container
                                    justifyContent="flex-start"
                                    alignItems={"end"}
                                    spacing={1}
                                    direction="row"
                                >
                                    <Grid item minWidth="16rem">
                                        <Controller
                                            control={control}
                                            name="group_id"
                                            render={({ field: { value } }) => (
                                                <Autocomplete
                                                    autoHighlight
                                                    value={value}
                                                    options={customerGroupsListShow}
                                                    fullWidth
                                                    renderInput={(params) => <TextField {...params} label={`グループ名`} size="small" style={{ background: palette.background.paper }} />}
                                                    onChange={(_, data) => setValue("group_id", data)}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    {
                                        authRole && authRole.base_view_flag == 1 && 
                                        <Grid item minWidth="16rem">
                                            <Controller
                                                control={control}
                                                name="settingBase"
                                                render={({ field }) => (
                                                    <Autocomplete
                                                        {...field}
                                                        disableCloseOnSelect
                                                        fullWidth
                                                        multiple
                                                        defaultValue={undefined}
                                                        size="small"
                                                        options={authRole.base_id_array}
                                                        isOptionEqualToValue={(option, value) => {return option.base_id === value.base_id}}
                                                        getOptionLabel={(option) => option.base_name}
                                                        onChange={(event, values) => {
                                                            field.onChange(values)
                                                        }}
                                                        renderOption={(field, option, { selected }) => (
                                                            <li {...field}>
                                                                <Checkbox
                                                                    checked={selected}
                                                                />
                                                                {option.base_name}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField sx={{backgroundColor:"white"}} {...params} label="拠点"/>
                                                        )}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    }
                                    <Grid item minWidth="16rem">
                                        <Controller
                                            control={control}
                                            name="customer_id"
                                            render={({ field: { value } }) => (
                                                <Autocomplete
                                                    autoHighlight
                                                    value={value}
                                                    options={customersOption}
                                                    fullWidth
                                                    renderInput={(params) => <TextField {...params} label={`${customerLabelName}名`} size="small" style={{ background: palette.background.paper }} />}
                                                    onChange={(_, data) => setValue("customer_id", data)}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item minWidth="16rem">
                                        <Controller
                                            name="place"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="text"
                                                    label="設置場所"
                                                    size="small"
                                                    style={{ background: palette.background.paper }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item minWidth="16rem">
                                        <Controller
                                            name="manage_customer_name"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="text"
                                                    label="管理組織名"
                                                    size="small"
                                                    style={{ background: palette.background.paper }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item minWidth="18rem">
                                        <Controller
                                            control={control}
                                            name="device_type"
                                            render={({ field: { value } }) => (
                                                <Autocomplete
                                                    autoHighlight
                                                    value={value}
                                                    options={deviceTypeOptions}
                                                    fullWidth
                                                    sx={{backgroundColor:"white"}}
                                                    renderInput={(params) => <TextField {...params} label="装置種別" size="small" />}
                                                    onChange={(_, data) => setValue("device_type", data)}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Button variant="outlined" style={{ background: palette.background.paper }} onClick={handleClearSeachCondition}>クリア</Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant="contained" onClick={handleSearch}>
                                            検索
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Collapse>
                        </div>
                    </Stack>
                </form >
                <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} spacing={1}>
                        <Grid item>
                            <TextField
                                fullWidth
                                autoComplete="searchStr"
                                name="keyword"
                                type="text"
                                label="フィルター"
                                size="small"
                                value={keyword}
                                onChange={e => handleChangeKeyword(e.target.value)}
                                />
                            </Grid>
                        <Button variant="outlined" size="small" onClick={() => handleChangeKeyword("")}>クリア</Button>
                    </Stack>
                </div>
                <div>
                    <NotifyGrid
                        ref={gridRef}
                        colState={colState}
                        pageSize={getValues('limit')}
                        pageData={pageData}
                        onChangeSearchCondition={handleChangePageData}
                        onShowDetails={handleShowDetail}
                        openSearch={openSearch}
                        keyword = {keyword}
                        authRole={authRole}
                    />
                </div>
            </div>
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId={menusFetchId} onComplete={(success, data, error) => success ? handleFetchAuthRoleSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId={CUSTOMER_GROUP_LIST} onComplete={(success, data, error) => success ? handleFetchCustomerGroupListSucess(data) : handleFetchCustomerGroupListError(success, data, error)} />
        </>
    );
    // #endregion Component

};

const mapStateToProps = (state: ApplicationState) => ({
    fetchStateMenu: selectors.getFetchState(
        state,
        menusFetchId
    ) as FetchState,
    initialPageSize: state.app.initialPageSize,
});

const mapDispatchToProps = {
    onGetAuthRole: () => actionCreators.fetch(menusFetchId, `/master/menus/get`, 'GET', null),
    onSearch: (params: { [key: string]: any }) => actionCreators.fetch(fetchId, `/master/notifications/get`, "GET", params),
    onSearchCustomerGroups: (params: { [key: string]: any }) => actionCreators.fetch(CUSTOMER_GROUP_LIST, `/master/customer-groups/get`,"GET",params),
    onChangePageSize: (pageSize: number) => actionCreators.setPageSize(pageSize),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "装置検索",
            body: "装置を検索できません。" + error,
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotifyList as any);
